import { NgModule } from '@angular/core'
import { TidioComponent } from './tidio.component'

@NgModule({
  declarations: [TidioComponent],
  exports: [TidioComponent]
})
export class TidioModule {}
